import { createFileRoute } from '@tanstack/react-router';

import { PersonalProfilePage } from '@/features/profiles/personal-profile-page';

export const Route = createFileRoute('/_app/profile')({ component: PersonalProfilePage });
